// extracted by mini-css-extract-plugin
module.exports = {"menuBlock":"af","title":"bf","nav":"cf","flexCell":"df","facetLink":"ef"};